<template>
  <DialogTutorialBase :delay-button="600" v-bind="props">
    <template #title>
      Flemme ? Sois malin, prends NOMAD+, l’abo 100% réussite ! 💕
    </template>
    <DomFade :delay="100">
      Tu rêves d’avoir <strong>tes fiches</strong> déjà
      <strong>toutes faites</strong> dans <strong>toutes les matières</strong> ?
    </DomFade>
    <DomFade :delay="120">
      <nuxt-link class="direct" :to="`${eva1Url}/premium`">
        <strong>NOMAD+</strong>
      </nuxt-link>
      , c’est ça + <strong>tes contenus illimités</strong> (exercices, remise à
      niveau, annales, Oral, tests, concours, orientation…) pour réussir
      <strong>ta scolarité</strong> et
      <strong>tes choix d’orientation</strong> 😇
    </DomFade>
    <DomFade tag="ul" :delay="320" class="buttons">
      <li>
        <ButtonBase
          theme="secondary"
          stroke="n"
          class="button"
          :disabled="false"
          rounded
          size="small"
          :to="`${eva1Url}/premium`"
        >
          Découvrir l’abonnement
        </ButtonBase>
      </li>
    </DomFade>
  </DialogTutorialBase>
</template>
<script lang="ts" setup>
interface Props {
  onNext: Function;
}
const props = defineProps({
  onNext: { type: Function }
});
const {
  public: { eva1Url },
} = useRuntimeConfig();
</script>
<style lang="scss" scoped>
.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
